import React from 'react';
const bonuses = [{
  icon: '🔥',
  title: 'Guía de Calentamiento y Enfriamiento',
  desc: 'Rutinas pre y post sesión. Reduce lesiones un 40%.'
}, {
  icon: '📅',
  title: 'Calendario de Temporada Anual',
  desc: '28 semanas con objetivos, evaluaciones y competencias.'
}, {
  icon: '🥗',
  title: 'Guía de Nutrición Básica',
  desc: 'Qué comer antes, durante y después del partido.'
}, {
  icon: '🔍',
  title: 'Guía de Análisis del Rival',
  desc: 'Planilla de 5 datos para ventaja táctica.'
}, {
  icon: '💪',
  title: 'Test de Condición Física',
  desc: 'Tests con tablas de referencia por edad y posición.'
}, {
  icon: '📝',
  title: 'Reglamento Interno del Equipo',
  desc: 'Documento listo para firmar desde el día 1.'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0F] py-16 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            + <span className="text-[#FF6B00]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-[#B0B0C0] text-sm" data-id="element-6">
            Incluidos sin costo extra · Valor total:{' '}
            <span className="text-[#FFD700] font-bold line-through" data-id="element-7">
              USD 39
            </span>{' '}
            <span className="text-[#00C2FF] font-black" data-id="element-8">GRATIS</span>
          </p>
        </div>

        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl divide-y divide-[#FF6B0033]" data-id="element-9">
          {bonuses.map((bonus, i) => <div key={i} className="flex items-center gap-4 px-5 py-4" data-id="element-10">
              <span className="text-2xl flex-shrink-0" data-id="element-11">{bonus.icon}</span>
              <div className="flex-1 min-w-0" data-id="element-12">
                <h4 className="text-white font-bold text-sm" data-id="element-13">{bonus.title}</h4>
                <p className="text-[#B0B0C0] text-xs mt-0.5" data-id="element-14">{bonus.desc}</p>
              </div>
              <span className="text-[#00C2FF] font-black text-xs flex-shrink-0" data-id="element-15">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}